import React,{useEffect,useState} from 'react';
import {useLang} from './i18n';
import {avatarSrc} from './avatar';
import {EmoteGlyph,customEmoteId} from './CustomEmotes';

// "View reactions": one tab per emoji with everyone who reacted with it.
export function ReactionsDialog({messageId,initial,request,onPerson}:{messageId:string;initial?:string;request:(u:string)=>Promise<any>;onPerson:(p:any)=>void}){
 const [,,tr]=useLang();
 const [groups,setGroups]=useState<{emoji:string;users:any[]}[]|null>(null),[active,setActive]=useState(initial||''),[error,setError]=useState('');
 useEffect(()=>{request('/messages/'+messageId+'/reactions').then((g:any[])=>{setGroups(g);if(!g.some(x=>x.emoji===active))setActive(g[0]?.emoji||'');}).catch((e:Error)=>setError(e.message));},[messageId]);
 const current=groups?.find(g=>g.emoji===active);
 return <div className="reactions-dialog">
  <h2>{tr('Reactions','Reaktionen')}</h2>
  {error&&<p className="form-error">{error}</p>}
  {groups&&!groups.length&&<p className="reactions-empty">{tr('No reactions yet.','Noch keine Reaktionen.')}</p>}
  {!!groups?.length&&<div className="reactions-layout">
   <div className="reactions-tabs" role="tablist">{groups.map(g=><button key={g.emoji} type="button" role="tab" aria-selected={g.emoji===active} className={g.emoji===active?'active':''} onClick={()=>setActive(g.emoji)}><span className="reactions-tab-emoji" title={g.emoji.replace(/^<a?:([a-z0-9_]+):.*$/,':$1:')}>{customEmoteId(g.emoji)?<EmoteGlyph value={g.emoji}/>:g.emoji}</span><b>{g.users.length}</b></button>)}</div>
   <ul className="reactions-users">{current?.users.map(u=><li key={u.id}><button type="button" onClick={()=>onPerson(u)}><img src={avatarSrc(u)||undefined} alt=""/><span><b>{u.displayName}</b><small>@{u.username}</small></span></button></li>)}</ul>
  </div>}
 </div>;
}
